import styled from "styled-components";
const Wrapper = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
  bottom: 0;
  margin-top: 3rem;
  @media (max-width: 768px) {
    margin-top: 6rem;
  }
  h3 {
    font-family: ${({ theme }) => theme.fonts.sofia};
    font-style: normal;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-weight: lighter;
    font-size: 1rem;
    line-height: 100%;
    width: 80%;
    color: ${({ theme }) => theme.white};
  }
`;

function CardText({ children }) {
  return (
    <Wrapper>
      <h3>{children}</h3>
    </Wrapper>
  );
}

export default CardText;
